import cx from "classnames";
import React, { useCallback, useMemo } from "react";
import { useScrollVisible } from "../../../../common/util/useScrollVisible";

import { Block as BlockType, Dispatch } from "../types";
import { blockIsTable } from "../util";
import { Editor } from "./Editor";
import { useScrollToActiveTextBlock } from "./useScrollToActiveTextBlock";

type Props = Readonly<{
  active: boolean;
  block: BlockType;
  selectedCellId: string;
  dispatch: Dispatch;
  scrollRef: HTMLElement;
  scrollTo: boolean;
  readonly: boolean;
}>;

const isBlockInvalid = (block: BlockType): boolean => {
  if (blockIsTable(block)) {
    return block.cells.some(r => r.some(c => !c.validXml));
  }
  return !block.validXml;
};

export const Block = ({ active, block, dispatch, scrollRef, scrollTo, selectedCellId, readonly}: Props) => {  

  const [ref, setRef, isVisible] = useScrollVisible(scrollRef, "0px");
  const onClick = useCallback(() => {
    if (active) {
      return;
    }
    dispatch({
      blockId: block.id,
      type: "MARK BLOCK ACTIVE",
    });
  }, [active, block.id, dispatch]);
  useScrollToActiveTextBlock(scrollRef, ref, scrollTo);
  const editor = useMemo(() => {
    // Not sure what this did, but it stopped from rendering
    // all the blocks until the user scrolls to the bottom which causes
    // problems when selecting blocks in the left panels - SB
    /*if (!isVisible) {
      return undefined;
    }*/
    return <Editor 
      readonly={readonly}
      block={block} 
      disabled={!active} 
      dispatch={dispatch} 
      active={active}
      selectedCellId={selectedCellId}
    />;
  }, [active, block, dispatch, isVisible, selectedCellId]);
  const blockClassName = cx("block", {
    invalid: isBlockInvalid(block),
  });
  return (
    <div dir="auto" className={blockClassName} onClick={onClick} ref={setRef}>
      {editor}
    </div>
  );
};
